export default __webpack_public_path__ + "navigation-examples-custom-location-indicator-1200-fed599fad21de3869f8f871c95751921.webp";